'use strict';

require('../../style/css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/modal/style/css.js
// module id = 363
// module chunks = 121